import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content-view"
};
import { onMounted, ref } from "vue";
import router from '@/router';
import { pageStyle } from "@/theme/sliderStyle";
import { ElIcon, ElRow } from "element-plus";
import { ArrowLeftBold } from "@element-plus/icons-vue";
import StageGenerator from "@/components/Stage/StageGenerator.vue";
import store from "@/store"; // refs

export default {
  __name: 'StageGeneratorPage',

  setup(__props) {
    const dramaId = ref(null);
    const stageId = ref(null); // functions

    const goBack = () => {
      router.back();
    };

    const closeGenerator = () => {
      if (dramaId.value) {
        router.push('/lounge');
      } else {
        store.commit('update_stage', null);
        router.back();
      }
    }; // lifecycle


    onMounted(() => {
      dramaId.value = router.currentRoute.value.params?.drama_id ?? null;
      stageId.value = router.currentRoute.value.params?.stage_id ?? null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        class: "nav-bar",
        onClick: goBack
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
          default: _withCtx(() => [_createVNode(_unref(ArrowLeftBold))]),
          _: 1
        }), _cache[0] || (_cache[0] = _createElementVNode("text", {
          class: "left-nav-title"
        }, "回退", -1))]),
        _: 1
      }), _createVNode(StageGenerator, {
        "drama-id": dramaId.value,
        "stage-id": stageId.value,
        onCloseGenerator: closeGenerator
      }, null, 8, ["drama-id", "stage-id"])])], 4);
    };
  }

};